import {SET_ELEMENT, LICENSE_FIX, SET_COPYRIGHT_LICENSE, COPYRIGHT_LICENSE_SHOW_MODAL} from '../constants/constants';

const excludeInitialState={
    element: {},
    isGlobalExclusionAvailable : false,
    domain: null
}

export const elementExclusion=(state=excludeInitialState, action={})=>{
    if(action.type===SET_ELEMENT){
        return {...action.payload}
    }
    return state
}


const licenseFixInitialState = {
    licenseToFix: {}
}

export const licenseFix = (state=licenseFixInitialState, action={})=>{
    if(action.type===LICENSE_FIX){
        return {
            licenseToFix: action.payload
        }
    }
    return state
}

const copyrightLicenseInitialState = {
    library: null
}
export const copyrightLicense = (state=copyrightLicenseInitialState, action={}) => {
    if(action.type===SET_COPYRIGHT_LICENSE) {
        return {
            library: action.payload.library
        }
    }
    return state
}